export default __webpack_public_path__ + "static/media/icon-search.8965be94.svg";